import React, { useEffect, useState } from 'react';
import api, { fmtNum, fmtINR } from '@/lib/api';
import { Loading, KpiCard } from '@/components/Shared';
import { Package, Truck, Route, Clock, Wallet, CheckCircle2 } from 'lucide-react';

export default function DriverStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get('/driver/stats').then((r) => setS(r.data)); }, []);
  if (!s) return <Loading />;
  return (
    <div className="space-y-4">
      <h2 className="font-display text-lg font-semibold">My Performance</h2>
      <div className="grid grid-cols-2 gap-3">
        <KpiCard label="Total Deliveries" value={fmtNum(s.total_deliveries)} icon={CheckCircle2} />
        <KpiCard label="Litres Delivered" value={fmtNum(s.total_litres_delivered)} icon={Package} />
        <KpiCard label="Distance" value={`${fmtNum(s.distance_travelled_km)} km`} icon={Route} />
        <KpiCard label="Working Hours" value={`${s.working_hours} h`} icon={Clock} />
        <KpiCard label="Today's Jobs" value={fmtNum(s.today_total)} icon={Truck} />
        <KpiCard label="Incentives" value={fmtINR(s.earnings)} icon={Wallet} />
      </div>
    </div>
  );
}
